import React from 'react'
import SamLogo from '../assets/Sam_logo 1.png'
import CustomForm from '../components/CustomForm'
import { Col, Row } from 'antd'

import smSportsLOgo from '../assets/smSportsLOgo.png'
import SMLOGO from '../assets/SMLOGO.png'
import roadMap from '../assets/road_map_SS.png'

// sm team logos
import smLogo1 from '../assets/teamLogos/smLogo1.png'
import smLogo2 from '../assets/teamLogos/smLogo2.png'
import smLogo3 from '../assets/teamLogos/smLogo3.png'
import smLogo4 from '../assets/teamLogos/smLogo4.png'
import smLogo5 from '../assets/teamLogos/smLogo5.png'
import smLogo6 from '../assets/teamLogos/smLogo6.png'

// screen sizes img
import screen1 from '../assets/screen1.png'
import screen2 from '../assets/screen2.png'
import screen3 from '../assets/screen3.png'

// companies logos
import companyLogo1 from '../assets/companyLogos/companyLogo1.png'
import companyLogo2 from '../assets/companyLogos/companyLogo2.png'
import companyLogo3 from '../assets/companyLogos/companyLogo3.png'
import companyLogo4 from '../assets/companyLogos/companyLogo4.png'
import companyLogo5 from '../assets/companyLogos/companyLogo5.png'
import companyLogo6 from '../assets/companyLogos/companyLogo6.png'
import companyLogo7 from '../assets/companyLogos/companyLogo7.png'
import companyLogo8 from '../assets/companyLogos/companyLogo8.png'
import companyLogo9 from '../assets/companyLogos/companyLogo9.jpeg'
import companyLogo10 from '../assets/companyLogos/companyLogo10.jpeg'
import ConnectWallet from './ConnectWallet'

const BuyToken = () => {
  return (
    <div className='buy-token-page'>
      <div className='top'>
        <img src={SamLogo} />
        <div style={{ position: 'absolute', top: '0', right: '0', marginTop: '25px' }}>
          <ConnectWallet />
        </div>
        <div className='top-text'>
          <p>SAMS TOKEN is coming soon on the exchange </p>
        </div>
        <div className='topSpace'></div>
      </div>
      <div className='section_1'>
        <div className='wrapper'>
          <CustomForm />
        </div>
      </div>
      <div className='section_2'>
        <img className='samSports' src={SMLOGO} style={{ width: '8%' }} />
        <div
          className='wrapper'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            rowGap: '3rem',
            flexDirection: 'column',
            padding: '4rem',
          }}
        >
          <h2>What is the SAMS TOken?.0</h2>
          <p>
            SAMS Token is the IN-GAME currency of SAM SPORTs, The most REALISTIC SPORTS fantasy
            PLatform in the world. It allows its users to own their teams and control their teams,
            replicating the GM roles.
          </p>
          <button>
            {' '}
            <a
              href='https://www.canva.com/design/DAFql_zkhSs/NKM1sGOeMXhQnFK0sfTU4Q/view?utm_content=DAFql_zkhSs&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink'
              rel='noreferrer'
              target='_blank'
              style={{ textDecoration: 'none', color: '#000', fontWeight: 'bold' }}
            >
              {' '}
              WHitepaper
            </a>{' '}
          </button>
        </div>
      </div>
      <div className='section_3'>
        <img className='samSports' src={SMLOGO} style={{ width: '8%' }} />
        <div className='wrapper' style={{ paddingBottom: '2rem' }}>
          <h2>Our TOKENOMICS</h2>
          <Row gutter={[30, 30]}>
            <Col lg={12} md={12} sm={24} xs={24}>
              <div className='leftText'>
                <div>
                  <h4>Total token Supply</h4>
                  <ul>
                    <li> 1,000,000,000</li>
                    <li> Token Type:ERC20</li>
                    <li>Token Initial: SAMS</li>
                    <li>Price; $.004</li>
                    <li>DEX Liquidity (10%) : 100,000,000</li>
                    <li>Exchange (10%):100,000,000</li>
                  </ul>
                </div>
                <button>
                  {' '}
                  <a
                    rel='noreferrer'
                    href='https://www.canva.com/design/DAFtVRavSMY/VxeNtDL05fQtGZV_G_vkIA/view?utm_content=DAFtVRavSMY&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink#2'
                    target='_blank'
                    style={{ textDecoration: 'none', color: '#fff', fontWeight: 'bold' }}
                  >
                    TOKENOMICS
                  </a>{' '}
                </button>
              </div>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <div className='rightText'>
                <h4>Vesting Functionality:</h4>
                <ul>
                  <li>Users will have their tokens vested over 3 or 6 months cycles.</li>
                  <li>At the end of each cycle, users can claim 40% of their vested balance.</li>
                  <li>
                    This gradual release helps manage the token distribution and prevents sudden
                    market influxes from large token holders.
                  </li>
                </ul>
                <h4>Staking with Instant Exit Option: </h4>
                <ul>
                  <li> Users can stake their tokens for a specified period to earn rewards.</li>
                  <li>
                    The rewards are time-based and dependent on the staked token amount and
                    duration.
                  </li>
                  <li>Users have the option to exit their staking position instantly if needed.</li>
                  <li>
                    This feature encourages users to lock up tokens for a certain time in exchange
                    for rewards.
                  </li>
                </ul>
                <h4>Whale Protection:</h4>
                <ul>
                  <li>
                    To prevent large token holders (whales) from creating excessive volatility or
                    manipulation, a transaction limit of 50% is imposed.
                  </li>
                  <li>
                    This limit indirectly locks 25% of the whales&apos; tokens for a longer period,
                    reducing the potential for rapid token dumping.
                  </li>
                </ul>
                <h4>Token Burning Strategy:</h4>
                <ul>
                  <li>
                    Token burning involves removing a certain number of tokens from circulation,
                    reducing the total supply.
                  </li>
                  <li>
                    Each transaction incurs a 35% burn rate, which means that a portion of tokens
                    used in transactions will be burned.
                  </li>
                  <li>
                    This strategy can potentially lead to deflationary effects over time, increasing
                    scarcity and potentially positively impacting token value
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className='section_4'>
        <img className='samSports' src={SMLOGO} style={{ width: '8%' }} />
        <div className=''>
          <div className='heading'>
            <h2>our GAMES</h2>
            <p>100 + Pro Teams Owned Already!!!!!</p>
            <p>4 Fantasy Sport Leagues</p>
            <p>1 Legend Esport championship</p>
            <p>SAM Scouts: Discover the stars of tomorrow</p>
          </div>
          <div
            className='teamLogos'
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Row>
              <Col lg={8} md={12} sm={24} xs={24}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smLogo2} />
                </div>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smLogo3} />
                </div>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smLogo6} />
                </div>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smLogo4} />
                </div>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smLogo5} />
                </div>
              </Col>
              <Col lg={8} md={12} sm={24} xs={24}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smLogo1} />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className='section_5'>
        <img className='samSports' src={SMLOGO} style={{ width: '8%' }} />
        <div className='wrapper'>
          <h2>
            RUN YOUR <span>TEAMS</span> LIKE IN <span>GMs</span>
          </h2>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <Row>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ul>
                  <li>Salary cap</li>
                  <li>Practice squad</li>
                  <li>Injured Reserve</li>
                  <li>Scouts</li>
                  <li>Full Roster</li>
                </ul>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ul>
                  <li>Trade</li>
                  <li>You own your team</li>
                  <li>You own the players</li>
                  <li>Auctions</li>
                  <li>Full actual ligue size</li>
                </ul>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ul>
                  <li>Large prize Pool </li>
                  <li>In-game messenger</li>
                  <li>SAM metric points system</li>
                </ul>
              </Col>
            </Row>
          </div>
          <div
            className='screenSizes'
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <img src={screen1} className='laptop' />
            <img src={screen2} className='tablet' />
            <img src={screen3} className='phone' />
          </div>
        </div>
      </div>
      <div className='section_6'>
        <img className='samSports' src={SMLOGO} style={{ width: '8%' }} />
        <div
          className='wrapper'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h2>Our ROADMAP </h2>
          <img src={roadMap} />
        </div>
      </div>
      <div className='section_7'>
        <img className='samSports' src={SMLOGO} style={{ width: '8%' }} />
        <div className='wrapper'>
          <h2>
            our <span>PARTNERS</span>{' '}
          </h2>
          <div className='companyLogos'>
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}>
                <div className='left'>
                  <img src={companyLogo9} style={{ width: '40%' }} />
                  <img src={companyLogo1} />
                  <img src={companyLogo7} />
                  <img src={companyLogo5} />
                  <img src={companyLogo4} />
                </div>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
                <div className='left'>
                  <img src={companyLogo6} style={{ width: '45%' }} />
                  <img src={companyLogo3} />
                  <img src={companyLogo10} style={{ width: '20%' }} />
                  <img src={companyLogo8} />
                  <img src={companyLogo2} />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className='section_8'>
        <div className='wrapper'>
          <Row>
            <Col lg={12} md={12} sm={24} xs={24}>
              <div
                className='left'
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <img src={smSportsLOgo} />
              </div>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <div className='right'>
                <img src={SMLOGO} />
                <p>
                  c/ d’elisa 17, atico 3<br />
                  08023 Barcelona
                  <br />
                  Spain
                  <br />
                  https://Samsports.io
                  <br />
                  support@metasportarena.com
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default BuyToken
